import { render, staticRenderFns } from "./project_agents_platform_index.vue?vue&type=template&id=c74afa28"
import script from "./project_agents_platform_index.vue?vue&type=script&lang=js"
export * from "./project_agents_platform_index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports